import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";
import React from "react";

type Props = {
  count: number;
  "data-testid"?: string;
};

const CountBadge: React.FC<Props> = ({ count, "data-testid": dataTestId }) => {
  return <Adornment $count={count} data-testid={dataTestId} />;
};

const Adornment = styled("span")(
  ({ theme, $count }) => css`
    display: inline-block;
    line-height: 32px;  
    &::after {
      display: flex;
      align-items: center;
      justify-content: center;
      content: "${$count}";
      width: auto;
      height: 26px;
      border-radius: 4px;
      padding: 0 4px;
      background-color: ${theme.palette.background.default};
      color: ${theme.palette.text.secondary};
      font-size: 14px;
      line-height: 21px;
      font-weight: 500;
    }
`
);

export default CountBadge;
